module.exports = __webpack_public_path__ + "static/media/blue-house-mushroom.14f7a420.jpg";